var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRenovation = function SvgRenovation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 27 27"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.2,
    d: "M1.464 25.467h23.933V1.533H1.464zm24.2.533H1.197a.267.267 0 0 1-.267-.267V1.267c0-.148.12-.267.267-.267h24.467c.147 0 .266.12.266.267v24.466c0 .148-.12.267-.266.267Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.2,
    d: "M3.437 23.494h8.148V3.506H3.437zm8.415.533H3.17a.267.267 0 0 1-.267-.267V3.24c0-.147.12-.267.267-.267h8.682c.147 0 .266.12.266.267v20.52c0 .147-.12.267-.266.267ZM23.69 24.027H15.01a.267.267 0 0 1-.267-.267v-6.708a.267.267 0 0 1 .533 0v6.442h8.149V3.506h-8.149v6.442a.267.267 0 0 1-.533 0V3.24c0-.148.12-.267.267-.267h8.681c.148 0 .267.12.267.267v20.52c0 .147-.12.267-.267.267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.748 6.663a.266.266 0 0 1-.188-.455L6.138 4.63a.267.267 0 1 1 .377.377L4.937 6.585a.27.27 0 0 1-.189.078M4.748 9.031a.266.266 0 0 1-.188-.455L8.506 4.63a.266.266 0 1 1 .377.377L4.937 8.953a.27.27 0 0 1-.189.078"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.2,
    d: "M14.22 15.74a1.057 1.057 0 0 1-1.056-1.056.267.267 0 0 1 .533 0 .523.523 0 0 0 1.045 0v-2.762a.13.13 0 0 0-.128-.128h-.79a.13.13 0 0 0-.127.128v1.183a.267.267 0 0 1-.533 0v-1.183c0-.365.296-.662.66-.662h.79c.365 0 .661.297.661.662v2.762c0 .582-.473 1.056-1.056 1.056"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.2,
    d: "M13.43 12.188a.267.267 0 0 1-.266-.267V1.267a.267.267 0 0 1 .533 0V11.92c0 .148-.12.267-.267.267M13.43 26a.267.267 0 0 1-.266-.267v-11.05a.267.267 0 0 1 .533 0v11.05c0 .148-.12.267-.267.267"
  }))));
};
export default SvgRenovation;